import React from "react"
import { Link } from "gatsby"
import Layout from "../../components/Layout"
import Header from "../../components/Header"
import { gradientLightPink } from "../../ds/gradients.module.css"
import { Helmet } from "react-helmet"
import PremagicNewsSection from "../../components/PremagicNews"

// List of reports - will grow over time
const reports = [
  {
    title: "Event EMV Calculator",
    description:
      "Free calculator to estimate your event's earned media value on LinkedIn. See how much organic reach your attendees could generate and what it would cost as paid advertising.",
    path: "/reports/emv-calculator/",
    date: "February 2026",
    thumbnailBg: "#1F0F61",
    tags: ["ROI Calculator", "Earned Media Value", "LinkedIn"],
  },
  {
    title: "2026 Master Event Calendar",
    description:
      "Complete list of must-attend events for event professionals in 2026. From IMEX to Web Summit - plan your year with our comprehensive event calendar.",
    path: "/reports/2026-event-calendar/",
    date: "February 2026",
    thumbnailBg: "#4f46e5",
    tags: ["Event Calendar", "Industry Events", "2026"],
  },
  {
    title: "Event Tech Research & Reports - AI Insights Hub",
    description:
      "Browse comprehensive event technology research, AI insights & industry reports. Data-driven analysis for smarter event decisions.",
    path: "/reports/attendee-generated-content-impact-report-2025/",
    date: "June 2025",
    thumbnailBg: "#7251f4",
    tags: ["Content Marketing", "UGC", "Event ROI"],
  },
  {
    title: "The Event Advocacy Playbook",
    description:
      "Learn how to transform your event participants into a powerful volunteer marketing army. Strategic playbook based on successful campaigns from major tech expos.",
    path: "/reports/event-advocacy-playbook/",
    date: "November 2025",
    thumbnailBg: "#f45142",
    tags: ["Advocacy Marketing", "Engagement", "Strategy"],
  },
]

const ReportsIndex = () => {
  return (
    <Layout
      title="Event Marketing Reports & Research | Premagic"
      description="Access our collection of free reports, studies, and research on event marketing trends, technology, and best practices."
      keywords={[
        "event technology reports, AI event insights, event industry research, event tech trends 2025, event marketing research, event platform analytics, MICE industry reports, conference technology insights, event data analysis, corporate event research, trade show analytics, event ROI research, networking event studies, event engagement research, digital event reports",
      ]}
    >
      <Helmet>
        <style>{`
          .report-card {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
            overflow: hidden;
          }
          
          .report-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
          }
          
          .report-thumbnail {
            height: 160px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-weight: 600;
            position: relative;
            overflow: hidden;
          }
          
          .report-thumbnail::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(135deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.4) 100%);
          }
          
          .tag {
            font-size: 11px;
            padding: 4px 10px;
            border-radius: 20px;
            background: #f1f4ff;
            color: #1F0F61;
            margin-right: 6px;
            margin-bottom: 6px;
            display: inline-block;
          }
          
          .report-date {
            font-size: 12px;
            color: #666;
            margin-bottom: 8px;
          }
          
        `}</style>
      </Helmet>

      <div className={gradientLightPink}>
        <Header />
        <div className="pm-container py-10 md:py-14">
          <h1
            className="font-bold text-2xl md:text-4xl text-center"
            style={{ color: "var(--color-blue-dark, #1F0F61)" }}
          >
            Event Marketing Reports & Research
          </h1>
          <p className="text-gray-600 mt-2 text-center max-w-2xl mx-auto">
            Access our latest insights, research, and trend reports to stay
            ahead in event marketing. All reports are free with email
            registration.
          </p>
        </div>
      </div>

      <div className="pm-container py-12">
        {/* Reports grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reports.map((report, index) => (
            <Link
              to={report.path}
              key={index}
              className="report-card rounded-lg overflow-hidden border border-gray-100 hover:no-underline"
            >
              <div
                className="report-thumbnail"
                style={{ backgroundColor: report.thumbnailBg }}
              >
                <span className="relative z-10 text-center px-4">
                  {report.title}
                </span>
              </div>
              <div className="p-5">
                <div className="report-date">{report.date}</div>
                <p className="text-gray-700 mb-3">{report.description}</p>
                <div>
                  {report.tags.map((tag, tagIndex) => (
                    <span key={tagIndex} className="tag">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <PremagicNewsSection />
    </Layout>
  )
}

export default ReportsIndex
